export default __webpack_public_path__ + "static/B0293-a212bf7d60000bbf8afd7046c56ac0c4.png";